import i18n from "i18next";
import getUserAgent from "storefront/lib/getUserAgent";

/**
 * @name isWebview
 * @description A function that determines whether the given user agent belongs to a webview.
 * We are in a webview if the user-agent contains the marketplace name.
 */
const isWebview = (userAgent: string = getUserAgent()): boolean =>
  userAgent.toLowerCase().includes(i18n.t("MARKETPLACE_NAME").toLowerCase());

export default isWebview;
